module.exports = __webpack_public_path__ + "static/media/Welcome.339e3755.jpg";